import React from "react";
import { getDotFormats } from "utils/fileUtils";

const UploadMedia = ({
  reference,
  inputName,
  handleInputChange,
  acceptedFormats,
}) => {
  return (
    <>
      <input
        name={inputName}
        ref={reference}
        onChange={handleInputChange}
        type="file"
        multiple={true}
        accept={getDotFormats(acceptedFormats)?.join(",")} // converting list of accepted formats to comma separated values
        id="file-upload"
        className="d-none"
      />
    </>
  );
};

export default UploadMedia;
